import { GenIcon } from '../helpers/IconBase.es.js';

const StarColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 17.7525L6.43769 20.119L6.96958 14.0976L3 9.53888L8.89103 8.18403L12 3L15.109 8.18403L21 9.53888L17.0304 14.0976L17.5623 20.119L12 17.7525Z",
          fill: "#FFA940"
        }
      }
    ]
  })(props);
};

export { StarColored };
